import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import Raphael from 'raphael';
import { AssessmentService } from '../services/assessment.service';
import { ActivatedRoute } from '@angular/router';
import { TeamSnapshotResponse } from '../models/teamsnapshotResponse.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-team-snapshot',
    templateUrl: './team-snapshot.component.html',
    styleUrl: './team-snapshot.component.less',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TeamSnapshotComponent implements OnInit {
  data: TeamSnapshotResponse;
  currentyear = new Date().getFullYear();
  constructor(private  readonly assessmentService : AssessmentService , private readonly route: ActivatedRoute, private readonly translateService: TranslateService){ }

  ngOnInit() {
    const uid = this.route.snapshot.queryParamMap.get('uid');
    const lang = this.route.snapshot.queryParamMap.get('lang');
    const baseline = this.route.snapshot.queryParamMap.get('baseline');

    this.translateService.use(lang);

    const data = {
      uid: uid,
      lang: lang,
      baseline: baseline
    }
    this.assessmentService.getTeamSnapshotDataUsingUID(data).subscribe((response: TeamSnapshotResponse) => {
      response.ReportDate = this.formatDate(response.ReportDate, lang);
      this.transformScoresData(response);
      this.data = response;
      const primaryTypeChartValues = Object.values(this.data.PrimaryType);
      const teamTraitsChartValues = Object.values(this.data.TeamTrait);
      this.createPieChart('primaryTypeChart', 'primaryTypeLabels', primaryTypeChartValues);
      this.createPieChart('teamTraitChart', 'teamTraitLabels', teamTraitsChartValues);
    });
    
    //this.data = JSON.parse(localStorage.getItem('teamSnapshotData'));
    
  }

  formatDate(param, lang) {
    const m_names = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const mpt_names = ["Janeiro", "Fevereiro", "Mar�o", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    const d = new Date(param);
    const curr_date = d.getDate();
    const curr_month = d.getMonth();
    const curr_year = d.getFullYear();
    if (lang === 'pt')
      return (mpt_names[curr_month] + " " + curr_date + ", " + curr_year);
    else
      return (m_names[curr_month] + " " + curr_date + ", " + curr_year);
  }

  transformScoresData(data) {
    const count = [];
    count["Pioneer"] = 1;
    count["Guardian"] = 1;
    count["Integrator"] = 1;
    count["Driver"] = 1;

    for (const x in data.Scores) { 
      if (!Object.prototype.hasOwnProperty.call(data.Scores, x)) {
        continue;
      }
      const temp = data.Scores[x].XYPoint;

      temp.Key = 50 + ((temp.Key - 0.25) * 100 * 2);
      temp.Value = 50 - ((temp.Value - 0.25) * 100 * 2);

      temp.Key = temp.Key * 0.945;
      temp.Value = temp.Value * 0.945;

      temp.Key = temp.Key + 4;
      temp.Value = temp.Value + 4;

      data.Scores[x].Count = count[data.Scores[x].PrimaryType];
      count[data.Scores[x].PrimaryType]++;
    }
  }

  createPieChart(chartId: string, labelsId: string, data?: any[]) {
    const size = 220;
    const paper = Raphael(chartId, size, size);
    const colors = ['#4764B3', '#F9B000', '#E81F25', '#18A625'];
   
    let total = 0;
    data.forEach(value => {
      total += value;
    });
   
    let angle = 0;
    const cx = size / 2; 
    const cy = size / 2;
    const outerRadius = size / 2;
    const innerRadius = outerRadius * 0.25;
    const gapAngle = 1.5;
   
    data.forEach((value, index) => {
      const percentage = Math.round(value / total * 100);
      const angleplus = 360 * value / total;
      const startAngle = angle + gapAngle / 2;
      const endAngle = angle + angleplus - gapAngle / 2;
      const middleAngle = (startAngle + endAngle) / 2;
      const p1 = this.getCoordinates(cx, cy, outerRadius, startAngle, endAngle);
      const p2 = this.getCoordinates(cx, cy, innerRadius, endAngle, startAngle);
      angle += angleplus;
      const largeArcFlag = angleplus > 180 ? 1 : 0;
      const fillColor = (data || []).includes(100) ? colors[(data || []).findIndex(e => e === 100)] : colors[index];
      const strokeColor = (data || []).includes(100) ? colors[(data || []).findIndex(e => e === 100)] : '#fff';
      const path = `M${p1.x1} ${p1.y1} A${outerRadius} ${outerRadius} 0 ${largeArcFlag} 1 ${p1.x2} ${p1.y2} L${p2.x1} ${p2.y1} A${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${p2.x2} ${p2.y2} Z`;
      paper.path(path).attr({ fill: fillColor, stroke: strokeColor, 'stroke-width': 1 });
   
      const labelDistance = 20;
      const textCoordinates = this.getCoordinates(cx, cy, (outerRadius + innerRadius) / 2 + labelDistance, middleAngle, middleAngle);
      this.addLabel(textCoordinates.x1, textCoordinates.y1, value, percentage, labelsId);
    });
  }
  
  getCoordinates(cx: number, cy: number, r: number, startAngle: number, endAngle: number) {
    const radians = Math.PI / 180;
    const x1 = cx + r * Math.cos(startAngle * radians);
    const y1 = cy + r * Math.sin(startAngle * radians);
    const x2 = cx + r * Math.cos(endAngle * radians);
    const y2 = cy + r * Math.sin(endAngle * radians);
    return { x1, y1, x2, y2 };
  }
  
  addLabel(x: number, y: number, value: number, percentage: any, labelsId: string) {
    if(percentage !== 0) {
      const labelsContainer = document.getElementById(labelsId);
      if (labelsContainer) {
        const label = document.createElement('div');
        label.innerText = `${percentage}%`; // Display value and percentage
        label.style.position = 'absolute';
        // Adjust the x and y to be relative to the labels container
        label.style.left = `${x + 1}px`; // +100 to adjust to the center of the labels container
        label.style.top = `${y + 1}px`;  // +100 to adjust to the center of the labels container
        label.style.transform = 'translate(-50%, -50%)'; // Center the label
        label.style.color = '#000';
        label.style.fontSize = '14px';
        labelsContainer.appendChild(label);
      }
    }
  }
}
